/* provoqué theme - cart drawer, grid toggle + colour filter, extra-dial picker, wishlist, search */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const R = window.PQ.routes;
  const html = document.documentElement;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const money = (cents, cur = (window.PQ.currency || 'chf')) => {
    const v = cents / 100;
    return cur.toLowerCase() + ' ' + (v % 1 ? v.toFixed(2) : v.toFixed(0));
  };
  const sized = (src, w) => { if (!src) return ''; const u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); };

  /* overlays */
  let lastFocus = null;
  const open = name => {
    lastFocus = document.activeElement;
    html.classList.add('is-' + name);
    const el = $('#' + name); el && el.setAttribute('aria-hidden', 'false');
    if (name === 'search') setTimeout(() => $('[data-q]')?.focus(), 50);
    if (name === 'cart') setTimeout(() => $('#cart [data-close]')?.focus(), 50);
  };
  const close = () => {
    ['cart', 'search'].forEach(n => { html.classList.remove('is-' + n); $('#' + n)?.setAttribute('aria-hidden', 'true'); });
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); if (o.dataset.open === 'cart') Cart.render().then(() => open('cart')); else open(o.dataset.open); }
    if (e.target.closest('[data-close]')) close();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  /* cart */
  const Cart = {
    async get() { const r = await fetch(R.cart + '.js?t=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } }); return r.json(); },
    async add(items) {
      const r = await fetch(R.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || 'could not add that.');
      await this.render(); open('cart');
    },
    async change(key, quantity) {
      await fetch(R.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      await this.render();
    },
    async render() {
      let c;
      try { c = await this.get(); } catch (e) { const l = $('[data-lines]'); if (l) l.innerHTML = '<p class="dr-empty">could not load the cart. pull to refresh.</p>'; return null; }
      if (!c || !Array.isArray(c.items)) { const l = $('[data-lines]'); if (l) l.innerHTML = '<p class="dr-empty">could not load the cart. pull to refresh.</p>'; return null; }
      window.PQ.currency = c.currency;
      $$('[data-cart-count]').forEach(n => n.textContent = c.item_count);
      const lines = $('[data-lines]'), foot = $('[data-foot]');
      if (!lines) return c;
      if (!c.items.length) { lines.innerHTML = '<p class="dr-empty">your cart is empty.</p>'; foot.hidden = true; return c; }
      foot.hidden = false;
      lines.innerHTML = c.items.map(i => `
        <div class="dr-line">
          <img src="${esc(sized(i.image, 160))}" alt="${esc(i.product_title)}" loading="lazy">
          <div><a href="${esc(i.url)}">${esc(i.product_title)}</a>${i.quantity > 1 ? ' <span class="mute">x' + i.quantity + '</span>' : ''}
          <button type="button" class="dr-rm" data-rm="${esc(i.key)}">remove</button></div>
          <div>${money(i.final_line_price, c.currency)}</div>
        </div>`).join('');
      $('[data-subtotal]').textContent = money(c.total_price, c.currency);
      return c;
    }
  };
  document.addEventListener('click', async e => {
    const rm = e.target.closest('[data-rm]');
    if (rm) { rm.textContent = '...'; await Cart.change(rm.dataset.rm, 0); }
  });

  const busy = async (btn, fn) => {
    const t = btn.textContent; btn.disabled = true; btn.textContent = 'adding...';
    try { await fn(); btn.textContent = 'added'; setTimeout(() => { btn.textContent = t; btn.disabled = false; }, 1400); }
    catch (err) { btn.textContent = String(err.message || err).toLowerCase(); setTimeout(() => { btn.textContent = t; btn.disabled = false; }, 2600); }
  };

  /* product page */
  const pdp = $('[data-pdp]');
  if (pdp) {
    $$('[data-add]', pdp).forEach(b => b.addEventListener('click', () => busy(b, () => Cart.add([{ id: +b.dataset.add, quantity: 1 }]))));

    const dialBtn = $('[data-add-dial]', pdp);
    if (dialBtn) dialBtn.addEventListener('click', async () => {
      const c = await Cart.get();
      const hasFrame = c.items.some(i => (i.product_type || '').toLowerCase() === 'watch');
      const note = $('[data-dial-note]', pdp);
      if (!hasFrame) { note.hidden = false; return; }
      note.hidden = true;
      busy(dialBtn, () => Cart.add([{ id: +dialBtn.dataset.addDial, quantity: 1 }]));
    });

    const ds = $('[data-dials]', pdp);
    if (ds) {
      const main = $('[data-main] img', pdp);
      const orig = main ? { src: main.src, srcset: main.srcset } : null;
      const combo = $('[data-add-combo]', ds);
      const track = $('[data-track]', ds);
      const sel = new Map();
      const show = src => {
        if (!main) return;
        const next = src ? { src, srcset: '' } : orig;
        if (main.src === next.src) return;
        main.style.opacity = 0;
        setTimeout(() => { main.srcset = next.srcset; main.src = next.src; main.onload = () => main.style.opacity = 1; setTimeout(() => main.style.opacity = 1, 400); }, 180);
      };
      const lastSel = () => [...sel.values()].pop();
      const update = () => {
        $$('.ds-item', track).forEach(b => b.setAttribute('aria-pressed', sel.has(b.dataset.id)));
        if (!sel.size) { combo.hidden = true; return; }
        const total = +pdp.dataset.price + [...sel.values()].reduce((a, b) => a + +b.dataset.price, 0);
        const what = sel.size === 1 ? lastSel().dataset.title : sel.size + ' dials';
        combo.textContent = `add ${pdp.dataset.title} + ${what} - ${money(total)}`;
        combo.hidden = false;
      };
      track.addEventListener('click', e => {
        const b = e.target.closest('.ds-item'); if (!b) return;
        if (sel.has(b.dataset.id)) sel.delete(b.dataset.id); else sel.set(b.dataset.id, b);
        update(); show(lastSel()?.dataset.watch);
      });
      if (matchMedia('(hover:hover)').matches) {
        track.addEventListener('mouseover', e => { const b = e.target.closest('.ds-item'); if (b) show(b.dataset.watch); });
        track.addEventListener('mouseleave', () => show(lastSel()?.dataset.watch));
      }
      combo.addEventListener('click', () => busy(combo, async () => {
        await Cart.add([{ id: +pdp.dataset.variant, quantity: 1 }, ...[...sel.keys()].map(id => ({ id: +id, quantity: 1 }))]);
        sel.clear(); update(); show(null);
      }));
      /* endless: clone the set on both sides and jump back when an edge is reached */
      const items = $$('.ds-item', track);
      if (items.length > 4) {
        const mk = () => items.map(n => { const c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; return c; });
        track.prepend(...mk()); track.append(...mk());
        const setW = () => items[0].offsetWidth * items.length;
        requestAnimationFrame(() => { track.scrollLeft = setW(); });
        track.addEventListener('scroll', () => {
          const w = setW();
          if (track.scrollLeft < w * 0.25) track.scrollLeft += w;
          else if (track.scrollLeft > w * 1.75) track.scrollLeft -= w;
        }, { passive: true });
      }
    }
  }

  /* grid: watches/dials toggle + colour filter + reveal 48 at a time */
  const grid = $('[data-grid]');
  if (grid) {
    const PAGE = 48;
    const others = grid.dataset.mode === 'others';
    let limit = PAGE;
    const params = new URLSearchParams(location.search);
    const state = { view: params.get('view') === 'dials' ? 'dials' : 'watches', color: params.get('color') };
    let map = [];
    try { map = JSON.parse($('#dial-map')?.textContent || '[]'); } catch (e) {}
    const byKey = Object.fromEntries(map.map(d => [d.k, d]));
    const seen = new Set();
    $$('.tile', grid).forEach(t => {
      const d = byKey[t.dataset.key];
      if (!d) { t.dataset.nodial = ''; return; }
      seen.add(d.k); t.dataset.d = d.url;
      const im = new Image(); im.className = 'tile-d'; im.loading = 'lazy'; im.alt = d.alt;
      im.src = d.img; t.append(im);
    });
    map.filter(d => !seen.has(d.k)).forEach(d => {
      const a = document.createElement('a');
      a.className = 'tile only-d'; a.href = d.url; a.dataset.d = d.url; a.dataset.key = d.k; a.dataset.color = d.c;
      a.innerHTML = `<img class="tile-d" loading="lazy" src="${esc(d.img)}" alt="${esc(d.alt)}">`;
      grid.append(a);
    });
    /* freddy's symbols: scattered between the watches, random each visit, not products */
    let symCfg = null;
    try { symCfg = JSON.parse($('#symbol-list')?.textContent || 'null'); } catch (e) {}
    if (symCfg && symCfg.files.length && !others) {
      const watches = $$('.tile', grid).filter(t => !t.classList.contains('only-d'));
      const count = Math.round(watches.length * symCfg.density / 10);
      const pool = [...symCfg.files].sort(() => Math.random() - .5);
      /* final grid positions: never next to each other, never in the same column one row apart
         (3 columns on phones, 6 on desktop), and not stacked two rows apart on phones */
      const total = watches.length + count;
      const rules = [[1, 2, 3, 4, 5, 6, 7, 9, 12], [1, 2, 3, 4, 5, 6, 7], [1, 2, 3, 5, 6, 7], [1, 3, 6]];
      let picked = [];
      for (const bad of rules) {
        picked = [];
        for (let tries = 0; tries < 400 && picked.length < count; tries++) {
          const p = 1 + Math.floor(Math.random() * (total - 1));
          if (picked.every(q => !bad.includes(Math.abs(p - q)))) picked.push(p);
        }
        if (picked.length >= count) break;
      }
      const set = new Set(picked);
      let w = 0, k = 0;
      const order = [];
      for (let p = 0; p < total; p++) {
        if (set.has(p) && k < count) {
          const d = document.createElement('div');
          d.className = 'tile sym'; d.setAttribute('aria-hidden', 'true');
          d.innerHTML = `<img src="${esc(pool[k % pool.length])}" alt="" loading="lazy">`;
          order.push(d); k++;
        } else if (w < watches.length) order.push(watches[w++]);
      }
      order.forEach(n => grid.append(n));
      $$('.tile.only-d', grid).forEach(n => grid.append(n));
    }
    const tiles = $$('.tile', grid);
    const empty = $('[data-empty]');
    const apply = () => {
      grid.classList.toggle('is-dials', state.view === 'dials');
      let shown = 0, visible = 0;
      tiles.forEach(t => {
        const sym = t.classList.contains('sym');
        const okView = sym || (state.view === 'dials' ? 'd' in t.dataset : !t.classList.contains('only-d'));
        const okColor = sym ? !state.color : (!state.color || t.dataset.color === state.color);
        const ok = okView && okColor;
        if (ok && !sym) visible++;
        t.hidden = !ok || shown >= limit;
        if (ok && shown < limit) shown++;
        if (!sym) t.href = state.view === 'dials' ? (t.dataset.d || t.href) : (t.dataset.w || t.href);
      });
      if (empty) empty.hidden = visible > 0;
      if (!others) $$('[data-v]').forEach(b => { const on = b.dataset.v === state.view; b.classList.toggle('is-on', on); on ? b.setAttribute('aria-current', 'page') : b.removeAttribute('aria-current'); });
      $$('[data-c]').forEach(b => b.setAttribute('aria-pressed', b.dataset.c === state.color));
      if (others) return visible;
      const p = new URLSearchParams();
      if (state.view === 'dials') p.set('view', 'dials');
      if (state.color) p.set('color', state.color);
      history.replaceState(null, '', location.pathname + (p.toString() ? '?' + p : ''));
      return visible;
    };
    document.addEventListener('click', e => {
      const v = e.target.closest('[data-v]'), c = e.target.closest('[data-c]');
      if (v && !others && v.dataset.v !== 'others' && map.length) { e.preventDefault(); state.view = v.dataset.v; apply(); }
      if (c) { state.color = state.color === c.dataset.c ? null : c.dataset.c; limit = PAGE; apply(); }
    });
    const visible = apply();
    const sentinel = $('[data-sentinel]');
    if (sentinel && 'IntersectionObserver' in window) new IntersectionObserver(es => {
      if (es[0].isIntersecting && limit < visible + PAGE) { limit += PAGE; apply(); }
    }, { rootMargin: '600px' }).observe(sentinel);
  }

  /* wishlist (on this device; keyed per customer when logged in) */
  const WL = {
    key: 'pq-wishlist' + (window.PQ.customer ? '-' + window.PQ.customer : ''),
    get() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    set(a) { try { localStorage.setItem(this.key, JSON.stringify(a)); } catch (e) {} this.sync(); },
    toggle(h) { const a = this.get(); const i = a.indexOf(h); i > -1 ? a.splice(i, 1) : a.unshift(h); this.set(a); },
    sync() {
      const a = this.get();
      $$('[data-wl-count]').forEach(n => n.textContent = a.length);
      $$('[data-wl]').forEach(b => { const on = a.includes(b.dataset.wl); b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? 'remove from wishlist' : 'save to wishlist'); });
    }
  };
  document.addEventListener('click', e => { const b = e.target.closest('[data-wl]'); if (b) WL.toggle(b.dataset.wl); });
  WL.sync();
  const wlGrid = $('[data-wl-grid]');
  if (wlGrid) (async () => {
    const hs = WL.get();
    const ps = (await Promise.all(hs.map(h => fetch(R.root.replace(/\/$/, '') + '/products/' + h + '.js').then(r => r.ok ? r.json() : null).catch(() => null)))).filter(Boolean);
    wlGrid.innerHTML = ps.map(p => `<a class="tile fade" href="${esc(p.url)}"><img class="tile-w" src="${esc(sized(p.featured_image, 540))}" alt="${esc(p.title)}" loading="lazy" style="${p.available ? '' : 'opacity:.25'}"></a>`).join('');
    $('[data-wl-empty]').hidden = ps.length > 0;
  })();

  /* predictive search: images only */
  const q = $('[data-q]'), out = $('[data-results]'), msg = $('[data-sr-msg]');
  if (q) {
    let t;
    q.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const term = q.value.trim();
        if (!term) { out.innerHTML = ''; msg.hidden = true; return; }
        try {
          const r = await fetch(`${R.suggest}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide`);
          const d = await r.json();
          const ps = d.resources.results.products || [];
          out.innerHTML = ps.map(p => `<a class="tile fade" href="${esc(p.url)}"><img class="tile-w" src="${esc(sized(p.image || p.featured_image?.url, 540))}" alt="${esc(p.title)}"></a>`).join('');
          msg.hidden = ps.length > 0;
          msg.textContent = `nothing for "${term}". try a number like 30one, or a colour.`;
        } catch (e) { msg.hidden = false; msg.textContent = 'search is down for a second. try again.'; }
      }, 180);
    });
  }

  Cart.render().catch(() => {});
})();
